export type SiteLanguage = "en" | "zh" | "zh-CN";
export type AssetLanguageKey = "en" | "zh";

export type LocalizedAsset<T = string> = Record<AssetLanguageKey, T>;

const SIMPLIFIED_CHINESE_CODES = ["zh-cn", "zh-sg", "zh-hans"];

export const normalizeSiteLanguage = (language?: string | null): SiteLanguage => {
  const normalized = String(language || "").trim().toLowerCase();

  if (normalized.startsWith("en")) return "en";
  if (
    SIMPLIFIED_CHINESE_CODES.some(
      (code) => normalized === code || normalized.startsWith(`${code}-`),
    )
  ) {
    return "zh-CN";
  }
  if (normalized.startsWith("zh")) return "zh";
  return "en";
};

export const getAssetLanguageKey = (
  language?: string | null,
): AssetLanguageKey =>
  normalizeSiteLanguage(language) === "en" ? "en" : "zh";

export const getHtmlLanguage = (language?: string | null) => {
  const siteLanguage = normalizeSiteLanguage(language);
  if (siteLanguage === "zh") return "zh-HK";
  return siteLanguage;
};
